import React from 'react'
import cn from 'classnames'
import { Trans, useTranslation } from '@mc/i18n'
import { TableFeature } from '@mc/plans-ui'
import { trackFreeGiftMembershipRowClick } from '../../../events/pageClick'
import { trackFreeGiftMembershipRowViewed } from '../../../events/rowViewed'
import { PLAN_Z_BOGO_I18N_NAMESPACE } from '../../../i18n'
import { FAQ_UUID } from '../../FAQ'
import styles from './FreeGiftBanner.module.scss'

/**
 * Full-width promo banner shown below the pricing row for Plan Z `variant_1` users.
 * "Learn more" smooth-scrolls to and opens the free-gift FAQ (replaces the previous
 * matrix-row info icon).
 */
export const FreeGiftBanner = () => {
  const { t } = useTranslation(PLAN_Z_BOGO_I18N_NAMESPACE)

  const handleLearnMoreClick = () => {
    trackFreeGiftMembershipRowClick()

    if (typeof window === 'undefined') return

    const heading = window.document.querySelector<HTMLElement>(
      `[data-uuid="${FAQ_UUID}"]`,
    )
    if (!heading) return

    heading.scrollIntoView({ behavior: 'smooth' })

    const button = heading.querySelector<HTMLButtonElement>(
      'button[aria-expanded="false"]',
    )
    if (!button) return

    button.focus()
    button.click()
  }

  return (
    <TableFeature.Feature
      className={cn(
        'no-border mc-corners--md mc-bg-neutral-800 mc-px-7 mc-py-4',
        styles.arrow,
      )}
      onFirstVisible={trackFreeGiftMembershipRowViewed}
    >
      <span className='mc-text-x-small'>
        <Trans
          i18nKey='banner.title'
          ns={PLAN_Z_BOGO_I18N_NAMESPACE}
          components={{ b: <span className='mc-text--bold' /> }}
        />
      </span>

      <button
        className={cn(
          'mc-clickable mc-text-x-small mc-text--underline',
          styles.link,
        )}
        onClick={handleLearnMoreClick}
      >
        {t('banner.learnMore')}
      </button>
    </TableFeature.Feature>
  )
}
